import { Tag, Tooltip } from 'antd';
import ColumnWithTooltip from 'containers/Reports/components/ColumnWithTooltip';
import { renderBoldPriceColumn, renderPriceColumn } from 'containers/Reports/utils';
import dayjs from 'dayjs';
import { getOrderType } from 'utils/order';
import { getPaymentType } from 'utils/orders';
import { capitalizeMerchantType } from 'utils';

const columns = (isMobile) => [
  {
    title: 'ORDER NUMBER',
    dataIndex: 'number',
    key: 'number',
    width: '140px',
    fixed: isMobile ? false : 'left',
  },
  {
    title: 'RESTAURANT',
    dataIndex: 'restaurant',
    key: 'restaurant',
    width: '200px',
    ellipsis: true,
    fixed: isMobile ? false : 'left',
  },
  {
    title: 'LOCATION',
    dataIndex: 'location',
    key: 'location',
    width: '160px',
    ellipsis: true,
  },
  {
    title: 'RESTAURANT TYPE',
    dataIndex: 'restaurant_type',
    key: 'restaurant_type',
    width: '150px',
    render: (value) => <Tag>{capitalizeMerchantType(value)}</Tag>,
  },
  {
    title: 'DELIVERED DATE',
    dataIndex: 'delivered_at',
    key: 'delivered_at',
    width: '160px',
    render: (value) => (value === '–' ? value : dayjs(value).utc(true).format('MMM D, hh:mm A')),
  },
  {
    title: 'State',
    dataIndex: 'state',
    key: 'state',
    width: '160px',
  },
  {
    title: 'TYPE',
    dataIndex: 'has_delivery',
    key: 'has_delivery',
    width: '120px',
    render: (_, record) => getOrderType(record),
  },
  {
    title: 'ORDER SOURCE',
    dataIndex: 'source',
    key: 'source',
    width: '160px',
    render: (value) => (value ? <Tag>{value?.toUpperCase()}</Tag> : null),
  },
  {
    title: 'PAYMENT TYPE',
    dataIndex: 'payment_type',
    key: 'payment_type',
    width: '130px',
    render: (value) => (value >= 0 ? <Tag>{getPaymentType(value)}</Tag> : null),
  },
  {
    title: () => <ColumnWithTooltip title="AMOUNT" description="Total charged to customer" />,
    dataIndex: 'amount',
    key: 'amount',
    width: '120px',
    render: renderBoldPriceColumn,
  },
  {
    title: () => <ColumnWithTooltip title="R.NET" description="Restaurant net" />,
    dataIndex: 'restaurant_portion',
    key: 'restaurant_portion',
    width: '110px',
    render: renderPriceColumn,
  },
  {
    title: 'COMMISSION',
    dataIndex: 'commission',
    key: 'commission',
    width: '130px',
    render: renderPriceColumn,
  },
  {
    title: 'MARKUP',
    dataIndex: 'markup',
    key: 'markup',
    width: '110px',
    render: renderPriceColumn,
  },
  {
    title: 'DELIVERY FEE',
    dataIndex: 'delivery_fee',
    key: 'delivery_fee',
    width: '120px',
    render: renderPriceColumn,
  },
  {
    title: 'SERVICE FEE',
    dataIndex: 'service_fee',
    key: 'service_fee',
    width: '120px',
    render: renderPriceColumn,
  },
  {
    title: 'TAX',
    dataIndex: 'tax',
    key: 'tax',
    width: '90px',
    render: renderPriceColumn,
  },
  {
    title: 'MARKUP TAX',
    dataIndex: 'markup_tax',
    key: 'markup_tax',
    width: '120px',
    render: renderPriceColumn,
  },
  {
    title: 'TIP',
    dataIndex: 'tip',
    key: 'tip',
    width: '90px',
    render: renderPriceColumn,
  },
  {
    title: 'PAYMENT FEE',
    dataIndex: 'payment_fee',
    key: 'payment_fee',
    width: '130px',
    render: renderPriceColumn,
  },
  {
    title: 'RESTAURANT PAYMENT FEE',
    dataIndex: 'restaurant_payment_fee',
    key: 'restaurant_payment_fee',
    width: '190px',
    render: renderPriceColumn,
  },
  {
    title: 'OTHER PAYMENT FEE',
    dataIndex: 'rds_payment_fee',
    key: 'rds_payment_fee',
    width: '160px',
    render: renderPriceColumn,
  },
  {
    title: 'EDITED',
    dataIndex: 'edited',
    key: 'edited',
    width: '80px',
    render: (value) => (value ? 'YES' : 'NO'),
  },
  {
    title: 'ADJUSTMENT',
    dataIndex: 'adjustment',
    key: 'adjustment',
    width: '130px',
    render: renderPriceColumn,
  },
  {
    title: 'SELF NOTES',
    dataIndex: 'self_notes',
    key: 'self_notes',
    width: '200px',
    ellipsis: {
      showTitle: false,
    },
    render: (note) => (
      <Tooltip placement="left" title={note}>
        {note}
      </Tooltip>
    ),
  },
  {
    title: 'INDEPENDENCY',
    dataIndex: 'has_integration_error',
    key: 'has_integration_error',
    width: '200px',
    ellipsis: {
      showTitle: false,
    },
    render: (hasError) => (
      hasError ? 'YES' : 'NO'
    ),
  },
  {
    title: 'TRANSFER ID',
    dataIndex: 'transfer_id',
    key: 'transfer_id',
    width: '150px',
  },
];
export default columns;
